/**
 *  페이지 이름
 */
export const CS_QNA_PAGE_NAME = {
  QNA_DETAIL: '상품 문의 상세',
  QNA_LIST: '상품 문의 리스트',
};

/**
 *  1:1 문의 답변 상태 이름
 */
export const CS_QNA_RESPONSE_STATUS_TEXT = {
  0: '미 답변',
  1: '답변 완료',
};

/**
 *  1:1 문의 답변 상태 SELECT 리스트
 */
export const CS_QNA_RESPONSE_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '미 답변',
  },
  {
    id: 1,
    name: '답변 완료',
  },
];

/**
 *  1:1 문의 오늘 출발 여부 상태 SELECT 리스트
 */
export const CS_QNA_TODAY_DELIVERY_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '일반',
  },
  {
    id: 1,
    name: '오늘 출발',
  },
];

/**
 *  상품 문의 답변 상태에 따른 답변하기 버튼 텍스트명
 */
export const QNA_RESPONSE_BUTTON_TEXT = {
  /**
   *  미 답변
   */
  false: '답변 작성하기',
  /**
   *  답변 완료
   */
  true: '수정하기',
};

/**
 *  상품 후기 문의 상태 이름
 */
export const CS_QNA_STATUS_TEXT = {
  0: '작성 완료',
  1: '구매자가 삭제',
  2: '관리자가 삭제',
};

/**
 *  상품 후기 문의 상태 SELECT 리스트
 */
export const CS_QNA_STATUS_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: 0,
    name: '작성 완료',
  },
  {
    id: 1,
    name: '구매자가 삭제',
  },
  {
    id: 2,
    name: '관리자가 삭제',
  },
];

/**
 *  상품 문의 상태
 */
export const CS_QNA_STATUS = {
  /**
   *  작성완료
   */
  SUBMIT: 0,
  /**
   *  구매자가 삭제
   */
  DELETE_FROM_USER: 1,
  /**
   *  관리자가 삭제
   */
  DELETE_FROM_ADMIN: 2,
};

/**
 *  답변까지 걸린 시간 날짜 포맷
 */
export const FORMAT_TIME_REPLY_DATE = 'DD일 hh시간 mm분';

/**
 *  노출 여부에 따른 메시지
 */
export const UPDATE_CS_QNA_ACTIVE_MESSAGE = {
  /**
   *  비 노출
   */
  false: '비 노출로 설정하면 앱에서 노출이 되지 않습니다.',
  /**
   *  노출
   */
  true: '노출로 설정하면 앱에서 노출이 됩니다.',
};

/**
 *  비밀글 여부에 따른 메시지
 */
export const UPDATE_CS_QNA_SECRET_MESSAGE = {
  /**
   *  비 노출
   */
  false: '해당 상품 문의의 비밀글 설정을 해제하시겠습니까?',
  /**
   *  노출
   */
  true: '해당 상품 문의를 비밀글로 설정하시겠습니까?',
};

/**
 *  상품 문의 리스트가 없을 때 보여주는 텍스트
 */
export const CS_QNA_LIST_TABLE_EMPTY_TEXT = '요청하신 검색 필터로 검색된 상품 문의 리스트가 없습니다.';

/**
 *  상품 문의 상세 > 유저의 다른 문의 내역이 없을 때 보여주는 텍스트
 */
export const CS_QNA_DETAIL_USERS_OTHER_TABLE_EMPTY_TEXT = '조회된 이 사람의 다른 문의 내역이 없습니다';

/**
 *  상품 문의 답변 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_QNA_ANSWER_TEXT = 2500;

/**
 *  상품 문의 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_QNA_MEMO_TEXT = 2500;

/**
 *  주문여부 타입
 */
export const ORDER_QNA_TYPE = {
  ORDER: 0,
  NOT_ORDER: 1,
};

/**
 *  주문여부 타입 텍스트
 */
export const ORDER_QNA_TYPE_TEXT = {
  [ORDER_QNA_TYPE.ORDER]: '주문',
  [ORDER_QNA_TYPE.NOT_ORDER]: '미주문',
};

/**
 *  주문여부 타입 SELECT LIST
 */
export const ORDER_QNA_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: ORDER_QNA_TYPE.ORDER,
    name: ORDER_QNA_TYPE_TEXT[ORDER_QNA_TYPE.ORDER],
  },
  {
    id: ORDER_QNA_TYPE.NOT_ORDER,
    name: ORDER_QNA_TYPE_TEXT[ORDER_QNA_TYPE.NOT_ORDER],
  },
];

// ==================== AI 답변 관련 상수 ====================

/**
 * AI 답변 키워드 최대 글자 수
 */
export const AI_REPLY_KEYWORD_MAX_LENGTH = 200;

/**
 * AI 답변 생성 API 타임아웃 (ms)
 */
export const AI_REPLY_API_TIMEOUT = 30000; // 30초

// ==================== AI 피드백 관련 상수 ====================

/**
 * AI 피드백 API 타임아웃 (ms)
 */
export const AI_FEEDBACK_TIMEOUT = 10000; // 10초

// ==================== 슬랙 알림 관련 상수 ====================

/**
 * 슬랙 알림 API 타임아웃 (ms)
 */
export const SLACK_NOTIFY_TIMEOUT = 10000; // 10초
